<template>
    <div class="Page Page--layout-sidebar">
        <!-- Head, nawigacja itd.-->
        <HeaderBody/>
        <!-- Page content -->
        <div class="Page__content page-content">
            <div class="sidebar sidebar-light sidebar-sections sidebar-main sidebar-expand-md align-self-start">

                <!-- Sidebar content -->
                <div class="sidebar-content">
                    <slot name="sidebar"></slot>
                </div>
                <!-- /Sidebar content -->
            </div>

            <!-- Main content -->
            <div class="content-wrapper">
                <!-- Content area -->
                <div class="content">
                    <slot/>
                </div>
            </div>
            <!-- /Main content -->
        </div>
    </div>
</template>

<script>

    import HeaderBody from '../../components/ApplicationHeader/HeaderBody';

    export default {
        name: "SidebarLayout",
        components: {HeaderBody},

    }
</script>

<style scoped>

    .content-wrapper {
        height: 100%;
    }

</style>
